var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgQuests(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "award"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M4.25893 11.0195V15.9895C4.25893 17.8095 4.25893 17.8095 5.97893 18.9695L10.7089 21.6995C11.4189 22.1095 12.5789 22.1095 13.2889 21.6995L18.0189 18.9695C19.7389 17.8095 19.7389 17.8095 19.7389 15.9895V11.0195C19.7389 9.19945 19.7389 9.19945 18.0189 8.03945L13.2889 5.30945C12.5789 4.89945 11.4189 4.89945 10.7089 5.30945L5.97893 8.03945C4.25893 9.19945 4.25893 9.19945 4.25893 11.0195Z",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#78716C"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M17.4994 7.63V5C17.4994 3 16.4994 2 14.4994 2H9.49937C7.49937 2 6.49937 3 6.49937 5V7.56",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#78716C"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M12.6289 10.9909L13.1989 11.8809C13.2889 12.0209 13.4889 12.1609 13.6389 12.2009L14.6589 12.4609C15.2889 12.6209 15.4589 13.1609 15.0489 13.6609L14.3789 14.4709C14.2789 14.6009 14.1989 14.8309 14.2089 14.9909L14.2689 16.0409C14.3089 16.6909 13.8489 17.0209 13.2489 16.7809L12.2689 16.3909C12.1189 16.3309 11.8689 16.3309 11.7189 16.3909L10.7389 16.7809C10.1389 17.0209 9.67891 16.6809 9.71891 16.0409L9.77891 14.9909C9.78891 14.8309 9.70891 14.5909 9.60891 14.4709L8.93891 13.6609C8.52891 13.1609 8.69891 12.6209 9.32891 12.4609L10.3489 12.2009C10.5089 12.1609 10.7089 12.0109 10.7889 11.8809L11.3589 10.9909C11.7189 10.4509 12.2789 10.4509 12.6289 10.9909Z",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#78716C"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    opacity: 0,
    d: "M23.4999 23.5L0.499903 23.5L0.499903 0.5L23.4999 0.5L23.4999 23.5Z",
    stroke: "#78716C"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuests);
export default __webpack_public_path__ + "static/media/quests.fa2daf2d15acafdb7765b75d8fc3f98b.svg";
export { ForwardRef as ReactComponent };